import PropTypes from 'prop-types';
import React from 'react';
import { SCTooltip } from 'rollup-allspark';

/**
 * Compact question-quota meter for the drawer header. Fed by GET /v1/kai/usage
 * and refreshed by the terminal `usage` SSE event after each answer.
 */
const UsageMeter = ({ usage }) => {
  if (!usage) return null;

  const used = usage.questions_used ?? 0;
  const limit = usage.questions_limit ?? 0;
  const pct = limit > 0 ? Math.min((used / limit) * 100, 100) : 0;
  const nearLimit = limit > 0 && used / limit >= 0.8;

  const tokensNote =
    usage.tokens_limit > 0
      ? `${(usage.tokens_used || 0).toLocaleString()} / ${usage.tokens_limit.toLocaleString()} tokens this month`
      : 'Token usage this month';

  return (
    <SCTooltip content={tokensNote}>
      <div className="flex items-center gap-x-2">
        <div className="h-1.5 w-16 overflow-hidden rounded-full bg-grey-light">
          <div
            className={`h-full rounded-full ${
              nearLimit ? 'bg-red' : 'bg-primary'
            }`}
            style={{ width: `${pct}%` }}
          />
        </div>
        <span
          className={`text-mini font-medium ${
            nearLimit ? 'text-red-dark' : 'text-grey-darker'
          }`}
        >
          {used}/{limit}
        </span>
      </div>
    </SCTooltip>
  );
};

UsageMeter.propTypes = {
  usage: PropTypes.shape({
    questions_used: PropTypes.number,
    questions_limit: PropTypes.number,
    tokens_used: PropTypes.number,
    tokens_limit: PropTypes.number,
  }),
};

export default UsageMeter;
